export default __webpack_public_path__ + "static/media/template.387c4201.svg";